var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuttlery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9222 0L18.9147 2.22625L16.6722 3.25L18.9147 4.27375L19.9222 6.5L20.946 4.27375L23.1722 3.25L20.946 2.22625L19.9222 0ZM12.6097 3.25L10.8385 7.16625L6.92224 8.9375L10.8385 10.7087L12.6097 14.625L14.3972 10.7087L18.2972 8.9375L14.3972 7.16625L12.6097 3.25ZM26.2435 8.3525C24.0822 8.2225 21.6122 9.18125 19.6622 11.115C17.0785 13.6988 16.266 17.1925 17.4197 19.6787L1.55974 35.5387L3.85099 37.83L15.0472 26.6663L26.2272 37.8463L28.5185 35.555L17.3385 24.375L19.7272 21.9862C22.2135 23.14 25.7072 22.3275 28.291 19.7437C31.3947 16.64 31.996 12.1875 29.6072 9.79875C28.7135 8.9375 27.5272 8.43375 26.2435 8.3525ZM1.90099 8.9375C0.683617 10.1584 0 11.8121 0 13.5363C0 15.2604 0.683617 16.9141 1.90099 18.135L8.70974 24.9275L13.3085 20.3125L1.90099 8.9375Z",
    fill: "#FF7D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuttlery);
export default __webpack_public_path__ + "static/media/cuttlery.8d6f2957ec102324d1e00002322d8fcb.svg";
export { ForwardRef as ReactComponent };